<template>
	<v-app>
		<v-row class="px-4">
      <LoadingDialog v-if="loading" :is_loading=loading></LoadingDialog>

      <!-- Graphs -->
      <v-col cols="12">
        <v-card
          v-if="!loading"
          elevation="0"
          style="margin-top: 15px;">
          <v-card-title>
            <v-row>
              <v-col>
                {{ $t('_module_expert_') }} : {{ $t("_expert_pvsyst_") }}
              </v-col>
              <v-col class="col-2">
                <dates-selector-expert
                    :store_date="$store.getters.dates"
                    :min_date="this.auditDates.start"
                    :max_date="this.auditDates.end"
                    :show_label="false"
                    :default_last_month="false"
                    store_cal_event="SET_EXPERT_CALENDAR_REFRESH"
                    store_date_commit="SET_EXPERT_DATES"
                />
              </v-col>
              <v-col class="col-2" cols=1>
                <v-text-field
                    :label="$t('_global_incline_mesurer_')"
                    type="number"
                    step="0.01"
                    v-model.number="globalIncline"
                    variant="underlined"
                    dense
                />
                <slot></slot>
              </v-col>
              <v-col class="col-2" cols=1>
                <v-text-field
                    :label="$t('_energie_compteur_AC_')"
                    type="number"
                    step="0.01"
                    v-model.number="energieCompteurAC"
                    variant="underlined"
                    
                    dense
                />
                <slot></slot>
              </v-col>
              <v-col class="col-2" cols=1>
                <v-btn @click="globalInclineUpdate()">
                  <Icon icon="tdesign:refresh" />
                </v-btn>
                <slot></slot>
              </v-col>
              </v-row>
          </v-card-title>
          <v-card-text>
            <ModulePvsyst  ref="pv_syst_ref"/>
          </v-card-text>
        </v-card>
      </v-col>
		</v-row>
	</v-app>
</template>
<script>
// import api from "@/api/api";
import LoadingDialog from "@/components/Utils/LoadingDialog";
import ModulePvsyst from "@/components/Pvsyst/ModulePvsyst.vue";
import DatesSelectorExpert from "@/components/Utils/DatesSelector";
import { Icon } from '@iconify/vue2';

export default {
  components: {
    LoadingDialog,
    ModulePvsyst,
    DatesSelectorExpert,
    Icon,
  },
  data() {
    return {
      loading: false,
      globalIncline: null,
      energieCompteurAC: null,
      installation_id: this.$route.params.id,
      expertDatesLoaded: false, // Track if dates are loaded
    };
  },
  mounted() {
    this.loadExpertDates();
  },
  computed: {
    installation() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.installation_id
      );
    },
    expertDates() {
      return this.$store.state.parametersStore.dates;
    },
    auditDates() {
      return this.$store.state.parametersStore.audit_dates;
    },
  },
  watch: {
    '$route': {
      handler() {
        this.loadExpertDates();
        this.resetGlobalValues();
      },
      immediate: true,
    },
    '$store.getters.expertCalendarRefresh': {
      async handler() {
        if (this.$store.getters.expertCalendarRefresh) {
          this.$store.commit('SET_EXPERT_CALENDAR_REFRESH', false);
          await this.$store.dispatch('setInstallationAuditDate', {
            start_date: this.$store.state.parametersStore.expert_dates.start,
            end_date: this.$store.state.parametersStore.expert_dates.end,
          });
        }
      },
      immediate: true,
    },
    '$store.getters.globalIncline': {
      handler() {
        this.globalIncline = this.$store.getters.globalIncline;
      },
      immediate: false,
    },
    '$store.getters.energieCompteurAC': {
      handler() {
        this.energieCompteurAC = this.$store.getters.energieCompteurAC;
      },
      immediate: false,
    },
  },
  methods: {
    async loadExpertDates() {
      // Check if dates are already loaded in the store
      if (!this.expertDates.start || !this.expertDates.end) {
        // If not, dispatch the action to load them
        await this.$store.dispatch('setInstallationExpertDate', {
          start_date: this.installation.audit_start_date,
          end_date: this.installation.audit_end_date,
        });
        this.expertDatesLoaded = true;
      } else {
        // If dates are loaded, mark as such
        this.expertDatesLoaded = true;
      }
    },
    resetGlobalValues() {
      this.$store.dispatch('setGlobalIncline', null);
      this.$store.dispatch('setEnergieCompteurAC', null);
      this.$store.dispatch('setInputData', null);
    },
    globalInclineUpdate() {
      this.$store.dispatch('setGlobalIncline', this.globalIncline);
      this.$store.dispatch('setEnergieCompteurAC', this.energieCompteurAC);
      this.$refs.pv_syst_ref.recalculate();
    },
    changeGlobalIncline(item) {
      this.globalIncline = item;
      this.$store.dispatch('setGlobalIncline', this.globalIncline);
    },
  },
};
</script>


<style scoped>
	.v-select-like {
		border: 1px solid black !important;
		width:100%;
		display: block;
		border-radius: 4px;
		outline: none;
		color: black;
	}

  .vue-treeselect {
    font-size: 0.9rem;
    font-weight: normal;
  }

  .v-card__subtitle, .v-card__text, .v-card__title {
    padding: 16px 16px 16px 16px;
    border-bottom: #eee solid 1px;
  }

  html {
    overflow: hidden !important;
  }

</style>
